
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources04Off as ObiSources04OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-04-off.js';
 
 
 

 
 export const ObiSources04Off = createComponent({
   react: React,
   tagName: 'obi-sources-04-off',
   elementClass: ObiSources04OffElement,
   events: {
     
   }
  });
 
 